(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryDeleteController',BatteryDeleteController);

    BatteryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Battery'];

    function BatteryDeleteController($uibModalInstance, entity, Battery) {
        var vm = this;
        vm.battery = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Battery.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
